module.exports = __webpack_public_path__ + "static/about-8a376864829b6a751856c33136362780.svg";